import * as React from 'react';
import { connect } from 'react-redux';

import Login from '@src/containers/login/Login';
import { RootState } from '@src/reducers';
import LoginOverlay from '@src/containers/login-overlay/LoginOverlay';
import './App.scss';
import { M } from '@src/controllers/M';
import Preloader from '@src/components/preloader/Preloader';
import { IPreloaderState } from '@src/reducers/PreloaderReducer';

interface IReduxState {
    isOverlayVisible: boolean;
    showPreloader: boolean;
}

interface IReduxActions {}

type IAllProps = IReduxState & IReduxActions;

class App extends React.Component<IAllProps, {}> {
    componentWillMount() {
        M.Config.init();
    }

    render() {
        const { isOverlayVisible, showPreloader } = this.props;

        return (
            <div className="App-wrap">
                {showPreloader && <Preloader darkBackground isFixed/>}
                <Login />
                {isOverlayVisible && <LoginOverlay key={'LoginOverlay'} />}
            </div>
        );
    }
}

const mapStateToProps = (state: RootState): IReduxState => {
    const LOGIN_STATE = state.loginState;
    const preloaderState: IPreloaderState = state.preloaderState;
    return {
        isOverlayVisible: LOGIN_STATE.isVisible,
        showPreloader: !LOGIN_STATE.isVisible && preloaderState.isVisible,

    };
};

const mapDispatchToProps = (dispatch: any): IReduxActions => {
    return {};
};

export default connect<IReduxState, IReduxActions, null>(
    mapStateToProps,
    mapDispatchToProps,
)(App);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App.tsx